/** Разделы конструктора реестров */
export enum ESectionName {
    main = 'main',
    structure = 'structure',
    map = 'map',
    views = 'views',
    forms = 'forms',
    access = 'access',
    relation = 'relation',
    schedule = 'schedule',
    api_settings = 'api_settings',
    legacy = 'legacy',
}

/** Список возможных представлений реестра */
export enum EViewTypes {
    kanban = 'kanban',
    timeline = 'timeline',
}

/** Способы отображения данных по связям */
export enum EViewRelation {
    /** Таблица с полями связи */
    TableRelation,
    /** Автодополнение */
    Autocomplete,
    /** Таблица с полями связанного реестра */
    TableRegistry,
    /** Диаграмма Ганта */
    FactorViewDataSource,
}

export enum EStructureFormComponentEvents {
    closeForm = 'closePage',
    deleteField = 'deleteField',
    addField = 'addField',
    save = 'filedFormSave',
}

export enum ERegistryFormComponentEvents {
    SaveRegistry = 'saveRegistry',
}

export enum EConstructorEvents {
    showSpinnerSelectFactorViewId = 'showSpinnerSelectFactorViewId',
    setOptionsSelectFactorViewId = 'setOptionsSelectFactorViewId',
    removeField = 'removeField',
    saveField = 'saveField',
}

export enum EStructureFormFields {
    fieldMaxlength = 'field_maxlength',
    textDefaultValue = 'text_default_value',
    stringDefaultValue = 'string_default_value',
    linkDefaultUrl = 'link_url',
    boolDefaultValue = 'bool_default_value',
    textUseEditor = 'text_use_editor',
    widthMax = 'width_max',
    heightMax = 'height_max',
    fileExt = 'file_ext',
    isCrop = 'is_crop',
    isPreview = 'is_preview',
    isShowFileInfo = 'is_show_file_info',
    isSubscribe = 'is_subscribe',
    listViewAsTree = 'list_view_as_tree',
    useAutocomplete = 'use_autocomplete',
    allowAddRubricator = 'allow_add_rubricator',
    useListFullName = 'use_list_full_name',
    selectMethod = 'select_method',
    listDefaultValue = 'list_string_default_value',
    rubricator = 'rubricator',
    listViewTreeAsFolder = 'list_view_tree_as_folder',
    selectTreeLevelOpen = 'select_tree_level_open',
    dataType = 'data_type',
    numerator = 'numerator',
    userAccessId = 'user_access_id',
    factorViewId = 'factor_view_id',
    viewOfDisplayingLinks = 'view_of_displaying_links',
    relationId = 'relation_id',
    isLinkInfoSite = 'is_link_info_site',
    stringType = 'string_type',
    availableRubricator = 'available_rubricator',
    codeAvailableRubricator = 'code_available_rubricator',
    stringMask = 'string_mask',
    stringValidation = 'string_validation',
    numberType = 'number_type',
    digitDefaultValue = 'digitDefaultValue',
    factorUnitId = 'factor_unit_id',
    factorUnitRatioId = 'factor_unit_ratio_id',
    isReportAvg = 'is_report_avg',
    calcRules = 'calc_right',
    blockType = 'block_type',
    isReadonly = 'is_readonly',
    intervalMin = 'interval_min',
    intervalMax = 'interval_max',
    dateType = 'type',
    dateFormatId = 'date_format_id',
    isCurrentDate = 'is_current',
    dateDefaultValueSingle = 'dateDefaultValueSingle',
    dateDefaultValueFrom = 'dateDefaultValueFrom',
    dateDefaultValueTo = 'dateDefaultValueTo',
    technicalProcessStatusId = 'technical_process_status_id',
    technicalProcessResultId = 'technical_process_result_id',
    technicalProcessDateId = 'technical_process_date_id',
    workSourceApplicationId = 'work_source_application_id',
    requestPlannedDateId = 'request_planned_data_id',
    requestRegistryId = 'request_registry_id',
    applicationId = 'application_id',
    resultAutomaticCompletionRequest = 'result_automatic_completion_request',
    requestCompletionStatus = 'request_completion_status',
    note = 'note',
    isHiddenView = 'is_hidden_view',
    showType = 'show_type',
    altSelectMethod = 'alternative',
    isDeleteView = 'is_delete_view',
    isShowInTabs = 'is_show_in_tabs',
    keyword = 'keyword',
    viewCondition = 'view_condition',
    storeType = 'store_type',
    storeJson = 'store_json',
}

export enum EDateTypes {
    date = 1,
    monthYear,
    year,
    month,
    dateTime,
    dayMonth,
}

export enum EStructureConditionFieldsDialog {
    main_value = 'main_value',
    second_value = 'second_value',
}

export enum EOperationType {
    filled = 'filled',
    notFilled = 'notFilled',
    match = 'match',
    notMatch = 'notMatch',
    Include = 'Include',
    notInclude = 'notInclude',
    contains = 'contains',
    notContains = 'notContains',
    more = 'more',
    moreOrEqual = 'moreOrEqual',
    less = 'less',
    lessOrEqual = 'lessOrEqual',
    later = 'later',
    laterEqual = 'laterEqual',
    earlier = 'earlier',
    earlierEqual = 'earlierEqual',
    inInterval = 'inInterval',
    foundOne = 'foundOne',
    notFoundOne = 'notFoundOne',
    fileSigned = 'fileSigned',
    nameFileInclude = 'nameFileInclude',
    durationEqual = 'durationEqual',
    durationMore = 'durationMore',
    durationLess = 'durationLess',
    beginsInInterval = 'beginsInInterval',
    endInInterval = 'endInInterval',
}

export enum ElistDateFormat {
    day = 1,
    month = 2,
    year = 3,
}
